import React from 'react'

import {
  ActionStrip,
  WebViewActionStrip,
  WebViewProps,
} from '@acorns/web-components'

type Props = WebViewProps & {
  actionStripTitle?: string
  isWebView?: boolean
  closeIcon?: boolean
  cancelLink?: boolean
  showCancellable?: boolean
  handleBack?: () => void
  handleCancel?: () => void
  showBack?: boolean
  shouldNotShowBack?: boolean
}

export const CloseAccountWrapper: React.FC<Props> = (props) => (
  <>
    {props.isWebView ? (
      <WebViewActionStrip
        title={props.actionStripTitle}
        action={props.action}
        link={props.link}
      />
    ) : (
      <ActionStrip
        maxWidth={800}
        actionText={props.actionStripTitle}
        title={props.actionStripTitle}
        actions={
          props.showCancellable === true
            ? [
                {
                  id: 0,
                  text: 'Cancel',
                  handler:
                    props.handleCancel ||
                    (() => {
                      throw new Error('No handler provided')
                    }),
                  actionText: 'Go back',
                },
              ]
            : undefined
        }
        onBack={props.handleBack || props.handleCancel}
        showBack={props.showBack}
      />
    )}

    {props.children}

    {/* render child - which should come from the product specific index page */}
  </>
)
